import React, { useState } from "react";
import { Bell, X, Mail } from "lucide-react";
import api, { apiError } from "@/lib/api";

/**
 * "Sledovat inzerát" – uživatel zadá e-mail a začne sledovat změny inzerátu.
 *
 * Props: listingId, listingTitle, onClose
 */
export default function WatchListingModal({ listingId, listingTitle, onClose }) {
  const [email, setEmail] = useState(localStorage.getItem("stb_buyer_email") || "");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/watchers/listing", {
        listing_id: listingId,
        email: email.trim(),
      });
      localStorage.setItem("stb_buyer_email", email.trim());
      setDone(true);
    } catch (ex) {
      setErr(apiError(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
      onClick={onClose}
      data-testid="watch-listing-modal"
    >
      <div className="stb-card p-5 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <h3 className="stb-h text-xl text-white inline-flex items-center gap-2">
            <Bell size={18} className="text-[#FF6B00]" /> Sledovat inzerát
          </h3>
          <button onClick={onClose} className="text-[#A3A3A3] hover:text-white">
            <X size={18} />
          </button>
        </div>
        {done ? (
          <div className="mt-4 text-center" data-testid="watch-done">
            <p className="stb-h text-[#22C55E] text-lg">Sledování zapnuto ✓</p>
            <p className="text-[#A3A3A3] text-sm mt-1">
              Pošleme ti e-mail při každé změně ceny, nadpisu, popisu i při smazání inzerátu.
            </p>
            <button onClick={onClose} className="stb-btn stb-btn-primary mt-4">Zavřít</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-3 space-y-2">
            <p className="text-xs text-[#A3A3A3]">
              Inzerát: <strong className="text-white">{listingTitle}</strong>
            </p>
            <p className="text-xs text-[#A3A3A3]">
              Zadej e-mail a pošleme ti upozornění, jakmile prodejce změní cenu nebo popis. Odhlásit
              můžeš jedním kliknutím v každém e-mailu.
            </p>
            <div className="relative">
              <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A3A3A3]" />
              <input
                type="email"
                className="stb-input pl-9"
                placeholder="tvuj@email.cz"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="watch-email-input"
              />
            </div>
            {err && <p className="text-[#FF6B00] text-xs" data-testid="watch-error">{err}</p>}
            <div className="flex gap-2 pt-1">
              <button
                type="submit"
                disabled={busy}
                className="stb-btn stb-btn-primary flex-1"
                data-testid="watch-submit"
              >
                {busy ? "Posílám…" : "Sledovat"}
              </button>
              <button type="button" onClick={onClose} className="stb-btn stb-btn-ghost">Zrušit</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
